__turbopack_context__.v({
  "amount": "_2HO0BW_amount",
  "dropdown": "_2HO0BW_dropdown",
  "mobile-filters-button": "_2HO0BW_mobile-filters-button",
  "search-results-header": "_2HO0BW_search-results-header",
});
